<template lang="pug">
.daySwitcher
  .buttonLeft(@click='$emit("setPreviousWeek")') <
  .currentDate {{ getCurrentDate }}
  .buttonRight(@click='$emit("setNextWeek")') >
</template>

<script>

import {format} from "date-fns";

export default {
  name: 'DaySwitcher',
  props: {
    date_from: {},
    date_to: {},
  },
  computed: {
    getCurrentDate() {
      return `Неделя с ${format(this.date_from, 'DD.MM.YYYY')} г. по ${format(this.date_to, 'DD.MM.YYYY')}`;
    }
  }
}
</script>

<style scoped lang="stylus">
.daySwitcher
  font-family: 'Open Sans', sans-serif;
  font-weight bold
  display flex
  flex-direction row
  font-size 14px
  background-color: #242c58
  padding-left: 6px;
  padding-right: 6px;
  color: #fafafb;
  padding-top: 5px;
  padding-bottom: 5px;
  .buttonLeft
    cursor pointer
    padding-right: 5px;
  .buttonRight
    cursor pointer
    padding-left: 5px;
</style>


// WEBPACK FOOTER //
// DaySwitcher.vue?04d05428